import React from "react";

export default function DateTimeField({ field, value, onChange }) {
  return (
    <div className="mp-form-group">
      <label className="mp-form-label">{field._label}{field.required && " *"}</label>
      <input
        type="datetime-local"
        className="mp-form-input"
        value={value ?? ""}
        onChange={e => onChange(field.name, e.target.value)}
        // Native datetime-local only opens on the built-in icon by default; open it on a click
        // anywhere in the field too. showPicker() is a no-op where unsupported.
        onClick={e => e.currentTarget.showPicker && e.currentTarget.showPicker()}
      />
    </div>
  );
}
